package com.essntl.features.invoice.ui.allinvoice.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.core.utils.viewmodel.State
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoiceItem(
    qbInvoice: QuickbooksInvoice,
    loadingDownloadQuickbookIds: Set<String>,
    downloadQuickbooksInvoiceState: State<Pair<String, QuickbooksInvoice>>,
    onDownloadInvoice: () -> Unit,
    onClick: () -> Unit,
    enabled: Boolean,
) {
    Box(
        contentAlignment = Alignment.Center,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(2.spacing))
            .clickable(enabled = enabled) { onClick() }
            .padding(
                horizontal = 1.spacing,
                vertical = 1.spacing,
            ),
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(1.spacing),
            modifier = Modifier.align(Alignment.CenterStart),
        ) {
            Text(
                text = qbInvoice.DocNumber,
                style = MaterialTheme.esTypography.p1Medium16,
                overflow = TextOverflow.Ellipsis,
                maxLines = 1,
            )

            Text(
                text = qbInvoice.CustomerRef.name,
                style = MaterialTheme.esTypography.p1Medium16,
                overflow = TextOverflow.Ellipsis,
                maxLines = 1,
            )
        }

        InvoicingActionButtons(
            qbInvoice = qbInvoice,
            loadingDownloadQuickbookIds = loadingDownloadQuickbookIds,
            downloadQuickbooksInvoiceState = downloadQuickbooksInvoiceState,
            onDownloadInvoice = onDownloadInvoice,
            modifier = Modifier.align(Alignment.CenterEnd),
        )
    }
}